import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import Navbar from './components/Navbar';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import AdminDashboard from './components/dashboard/admin/AdminDashboard';
import TraineeDashboard from './components/dashboard/trainee/TraineeDashboard';
import CandidateDashboard from './components/dashboard/trainee/CandidateDashboard';
import StandaloneCallPage from './components/dashboard/trainee/StandaloneCallPage';
import { api } from './utils/api';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const redirect = searchParams.get('redirect');

  useEffect(() => {
    // Check if user is logged in on app load
    const token = localStorage.getItem('token');
    if (token) {
      fetchUserProfile(token);
    } else {
      setLoading(false);
    }
  }, []);

  const fetchUserProfile = async (token) => {
    try {
      const response = await api.get('api/auth/me');
      
      if (response.ok) {
        setUser(response.data.user);
      } else {
        localStorage.removeItem('token');
      }
    } catch (error) {
      console.error('Error fetching user profile:', error);
      localStorage.removeItem('token');
    } finally {
      setLoading(false);
    }
  };

  const login = (userData) => {
    setUser(userData);
    toast.success(`Welcome back, ${userData.name}!`);
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('token');
    toast.info('You have been logged out');
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#6b7280'
      }}>
        Loading...
      </div>
    );
  }

  return (
    <div className="App">
      <Navbar user={user} onLogout={logout} />
      <div className="container">
        <Routes>
          <Route 
            path="/" 
            element={
              user ? (
                user.role === 'admin' ? 
                  <Navigate to="/admin-dashboard" /> : 
                  <Navigate to="/trainee-dashboard" />
              ) : (
                <Navigate to="/login" />
              )
            } 
          />
          <Route 
            path="/login" 
            element={
              user ? (
                redirect ? (
                  <Navigate to={redirect} />
                ) : user.role === 'admin' ? 
                  <Navigate to="/admin-dashboard" /> : 
                  <Navigate to="/trainee-dashboard" />
              ) : (
                <Login onLogin={login} />
              )
            } 
          />
          <Route 
            path="/register" 
            element={
              user ? (
                user.role === 'admin' ? 
                  <Navigate to="/admin-dashboard" /> : 
                  <Navigate to="/trainee-dashboard" />
              ) : (
                <Register onRegister={login} />
              )
            } 
          />
          <Route 
            path="/admin-dashboard" 
            element={
              user && user.role === 'admin' ? (
                <AdminDashboard user={user} />
              ) : (
                <Navigate to="/login" />
              )
            } 
          />
          <Route 
            path="/trainee-dashboard" 
            element={
              user && user.role === 'trainee' ? (
                <TraineeDashboard user={user} />
              ) : user && user.role === 'candidate' ? (
                <CandidateDashboard user={user} />
              ) : (
                <Navigate to="/login" />
              )
            } 
          />
          <Route 
            path="/call" 
            element={<StandaloneCallPage />} 
          />
          {/* Catch-all route for undefined paths */}
          <Route 
            path="*" 
            element={
              user ? (
                user.role === 'admin' ? 
                  <Navigate to="/admin-dashboard" /> : 
                  <Navigate to="/trainee-dashboard" />
              ) : (
                <Navigate to="/login" />
              )
            } 
          />
        </Routes>
      </div>
    </div>
  );
}

export default App;
